export const GRILLA = 10;
export const RADIO_ASIENTO = 9;
export const MARGEN_SECTOR = 36;
// lugar a la izquierda de cada fila para su nombre
export const ANCHO_NOMBRE_FILA = 3 * RADIO_ASIENTO + 8;

export const ajustarAGrilla = (valor, paso = GRILLA) => Math.round(valor / paso) * paso;

export const limitar = (valor, min, max) => Math.min(Math.max(valor, min), max);

// Las sillas de una mesa no tienen posición guardada: se reparten alrededor
// según la forma. En una redonda, en círculo; en una rectangular, arriba y
// abajo, y en las cabeceras si sobran.
export const posicionesSillas = (mesa) => {
  const cantidad = mesa.sillas?.length || 0;
  if (cantidad === 0) return [];
  const cx = mesa.ancho / 2;
  const cy = mesa.alto / 2;

  if (mesa.forma !== "rectangular") {
    const radio = Math.max(mesa.ancho, mesa.alto) / 2 + RADIO_ASIENTO + 4;
    return mesa.sillas.map((_, i) => {
      const angulo = (2 * Math.PI * i) / cantidad - Math.PI / 2;
      return { x: cx + radio * Math.cos(angulo), y: cy + radio * Math.sin(angulo) };
    });
  }

  const separacion = RADIO_ASIENTO + 4;
  const cabeceras = cantidad > 4 && cantidad % 2 === 1 ? 1 : cantidad > 6 ? 2 : 0;
  const porLado = Math.ceil((cantidad - cabeceras) / 2);
  const posiciones = [];
  const lado = (y, n) => {
    for (let i = 0; i < n; i++) {
      posiciones.push({ x: (mesa.ancho * (i + 1)) / (n + 1), y });
    }
  };
  lado(-separacion, porLado);
  lado(mesa.alto + separacion, cantidad - cabeceras - porLado);
  if (cabeceras >= 1) posiciones.push({ x: -separacion, y: cy });
  if (cabeceras >= 2) posiciones.push({ x: mesa.ancho + separacion, y: cy });
  return posiciones;
};

// cajaDecorativo aproxima lo que ocupa un objeto; el texto no tiene ancho
// guardado y se estima por la cantidad de letras.
export const cajaDecorativo = (d) => {
  if (d.tipo === "linea") {
    const x2 = d.punto_final_x ?? d.x;
    const y2 = d.punto_final_y ?? d.y;
    return { minX: Math.min(d.x, x2), minY: Math.min(d.y, y2), maxX: Math.max(d.x, x2), maxY: Math.max(d.y, y2) };
  }
  if (d.tipo === "texto") {
    const tamano = d.font_size || 18;
    return { minX: d.x, minY: d.y, maxX: d.x + (d.texto || " ").length * tamano * 0.6, maxY: d.y + tamano * 1.2 };
  }
  return { minX: d.x, minY: d.y, maxX: d.x + (d.ancho || 0), maxY: d.y + (d.alto || 0) };
};

// cajaContenido: el rectángulo que ocupan filas, mesas y objetos, en coordenadas del sector.
export const cajaContenido = (sector) => {
  const puntos = [];
  (sector.decorativos || []).forEach((d) => {
    const caja = cajaDecorativo(d);
    puntos.push([caja.minX, caja.minY], [caja.maxX, caja.maxY]);
  });
  (sector.filas || []).forEach((fila) => {
    fila.asientos.forEach((a) => {
      puntos.push([a.x - RADIO_ASIENTO, a.y - RADIO_ASIENTO], [a.x + RADIO_ASIENTO, a.y + RADIO_ASIENTO]);
    });
    // el nombre de la fila ocupa lugar a la izquierda, salvo que no se muestre
    if (fila.nombre && fila.asientos.length > 0 && sector.editor?.numeracion !== "nada") {
      const primero = fila.asientos[0];
      puntos.push([primero.x - ANCHO_NOMBRE_FILA - RADIO_ASIENTO, primero.y]);
    }
  });
  (sector.mesas || []).forEach((mesa) => {
    puntos.push([mesa.x, mesa.y], [mesa.x + mesa.ancho, mesa.y + mesa.alto]);
    posicionesSillas(mesa).forEach((p) => {
      puntos.push(
        [mesa.x + p.x - RADIO_ASIENTO, mesa.y + p.y - RADIO_ASIENTO],
        [mesa.x + p.x + RADIO_ASIENTO, mesa.y + p.y + RADIO_ASIENTO]
      );
    });
  });
  if (puntos.length === 0) return null;
  const xs = puntos.map((p) => p[0]);
  const ys = puntos.map((p) => p[1]);
  return { minX: Math.min(...xs), minY: Math.min(...ys), maxX: Math.max(...xs), maxY: Math.max(...ys) };
};
